import { UserAuthLog } from "@interfaces/user/users";
import { createContext, useContext } from "react";

export const AuthLogContext = createContext<UserAuthLog>(undefined as any);
export const AuthLogProvider = AuthLogContext.Provider;

export function useAuthLogContext(): UserAuthLog | undefined {
    return useContext(AuthLogContext);
}